module.exports = __webpack_public_path__ + "img/lightbox_btn_03.7babf69e.jpg";